import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { useLocation } from "react-router";
import { usePermissions } from "../../common/PermissionContext";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const ExternalResultFormat = () => {

    const [resultFormatList, setResultFormatList] = useState<any[]>([]);
    const [sportsList, setSportsList] = useState<any[]>([]);
    const [sportId, setSportId] = useState("");
    const [formatId, setFormatId] = useState("");
    const [formatStatus, setFormatStatus] = useState("");
    const [formatName, setFormatName] = useState("");
    const [formats, setFormats] = useState({});
    const [attempts, setAttempts] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchResultFormats() {
            setIsLoading(true);
            const resultFormatResponse = await func.externalResultFormats(null);
            setResultFormatList(Array.isArray(resultFormatResponse) ? resultFormatResponse : [])
            setIsLoading(false);
        }
        fetchResultFormats();
    }, []);

    const filteredData = resultFormatList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.sportName}</span>;
    };

    const formatRender = (rowData) => {
        return <span>{rowData.extComSportFormat}</span>;
    };

    const attemptsRender = (rowData) => {
        return <span>{rowData.attempts}</span>
    }

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };


    async function newExtRsltFrmt() {
        setIsEdit(false);
        const sportResponse = await func.externalSports(null);
        setSportsList(Array.isArray(sportResponse) ? sportResponse : [])
        setSportId("");
        setFormatName("");
        setAttempts("");
        setOpenModal(true);
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editExtRsltFrmt(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const frmtId = rowData.extComSportId;
        return (
            <Link to="#" onClick={() => deleteExtRsltFrmt(frmtId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editExtRsltFrmt(rowData: { extComSportFormatId: any; }) {
        const frmtId = rowData.extComSportFormatId;
        setIsEdit(true)
        setOpenModal(true)
        const sportResponse = await func.externalSports(null);
        setSportsList(Array.isArray(sportResponse) ? sportResponse : [])
        const getDetails = await func.externalResultFormats(frmtId);
        setFormatId(getDetails.extComSportFormatId);
        setSportId(getDetails.extComSportId);
        setFormatName(getDetails.extComSportFormat);
        setAttempts(getDetails.attempts);
        setFormatStatus(getDetails.status)
        // const jsonData = JSON.parse(JSON.parse(getDetails.extComSportFormatDetails)); // your JSON string

        // setFormats(jsonData);
        // setFormatStatus(getDetails.status);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateExternalResultFormat();
            } else {
                const formData = new FormData();
                formData.append("extComSportId", sportId);
                formData.append("extComSportFormat", formatName);
                formData.append("attempts", attempts);
                // formData.append("extComSportFormatDetails", JSON.stringify(formats));

                // formData.forEach((value, key) => {
                //     console.log(`${key}: ${value}`);
                // });

                const createFormat = api.ExternalCompetitionResultFormat;
                fetch(createFormat, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateExternalResultFormat() {
        const formData = new FormData();
        formData.append("extComSportId", sportId);
        formData.append("extComSportFormat", formatName);
        formData.append("attempts", attempts);
        formData.append("status", formatStatus);

        const updateSprt = api.ExternalCompetitionResultFormat + '/' + formatId;
        fetch(updateSprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                console.log(result);

                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteExtRsltFrmt(sprtId: string) {
        const deleteSport = api.ExternalCompetitionSports + '/' + sprtId + '/0';
        fetch(deleteSport, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    const handleRowsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (!/^\d*$/.test(value)) return;

        setRows(value);

        if (!formatName.trim()) {
            Swal.fire("Please enter Format Name first");
            return;
        }

        if (value === "") {
            setFormats(prev => {
                const updated = { ...prev };
                delete updated[formatName];
                return updated;
            });
            return;
        }

        const count = parseInt(value);

        if (count > 5) {
            Swal.fire("Maximum 5 titles allowed");
            return;
        }

        const titles: Record<string, string> = {};

        for (let i = 1; i <= count; i++) {
            titles[`title${i}`] = "";
        }

        setFormats(prev => ({
            ...prev,
            [formatName]: titles
        }));
    };

    //     const handleRowsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const count = Number(e.target.value);

    //     const titles = Array(count).fill("");

    //     setFormats(prev => ({
    //         ...prev,
    //         [formatName]: titles
    //     }));
    // };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Result Formats</h4>
                                    {/* {currentPermissions.includes("add") ? */}
                                    <Link
                                        to="#"
                                        className="btn"
                                        onClick={() => { newExtRsltFrmt() }}
                                        data-bs-toggle="tooltip"
                                        style={{ fontSize: "24px", padding: "0px" }}
                                        title="Create Result Format">
                                        <i className="feather-plus" />&nbsp;
                                    </Link>
                                    {/* : null
                                    } */}
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComSportName"
                                                header="Sport"
                                                body={sportRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComSportFormatDetails"
                                                header="Result Format"
                                                body={formatRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="attempts"
                                                header="Attempts"
                                                body={attemptsRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {/* {currentPermissions.includes("edit") ? */}
                                            <Column
                                                className="text-link"
                                                body={editDetails}
                                            ></Column>
                                            {/* : null
                                            }
                                            {currentPermissions.includes("delete") ? */}
                                            <Column
                                                className="text-link"
                                                body={deleteDetails}
                                            ></Column>
                                            {/* : null
                                            } */}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="sm"
                centered
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Result Format</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                            <div className="col-lg-12">
                                <div className="input-space">
                                    <label className="form-label">Sport</label>
                                    <Select
                                        value={sportsList.find(sprt => sprt.extComSportId === sportId) ? {
                                            value: sportId,
                                            label: sportsList.find(sprt => sprt.extComSportId === sportId).extComSportName
                                        } : null}
                                        onChange={(e) => {
                                            setSportId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportsList.map(sprt => ({
                                            value: sprt.extComSportId,
                                            label: sprt.extComSportName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="input-space">
                                    <label className="form-label">Format Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="formatName"
                                        value={formatName}
                                        onChange={(e) => { setFormatName(e.target.value) }}
                                        placeholder="Enter Result Format" />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="input-space">
                                    <label className="form-label">Attempts</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="attempts"
                                        value={attempts}
                                        // onChange={handleRowsChange}
                                        onChange={(e) => { setAttempts(e.target.value) }}
                                        placeholder="Enter Number of Attempts"
                                        min={1}
                                        max={5}
                                    />
                                </div>
                            </div>

                        {/* <div className="row">
                            {athleteRows.length > 0 &&
                                Object.entries(athleteRows[0]?.FormatName?.[formatName] ?? {}).map(
                                    ([key, value], index) => (
                                        <div className="col-lg-2" key={key}>
                                            <div className="input-space">
                                                <label className="form-label">
                                                    Title {index + 1}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={value as string}
                                                    placeholder="Enter Title"
                                                    onChange={(e) => {
                                                        const updated = [...athleteRows];
                                                        updated[0].FormatName[formatName][key] = e.target.value;
                                                        setAthleteRows(updated);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )
                                )}
                        </div> */}

                        <div className="row">
                            {Object.entries(formats).map(([name, titles]) => (
                                <div key={name} className="mb-4">

                                    <h5 className="mb-3">{name}</h5>

                                    {/* {isEdit ? (
                                        <div className="col-lg-4">
                                            <input
                                                type="text"
                                                className="form-control mb-3"
                                                value={name}
                                                onChange={(e) => {
                                                    const newName = e.target.value;

                                                    // Don't do anything if the name hasn't changed
                                                    if (newName === name) return;

                                                    setFormats(prev => {
                                                        const updated = { ...prev };

                                                        // Create the new key
                                                        updated[newName] = updated[name];

                                                        // Remove the old key
                                                        delete updated[name];

                                                        return updated;
                                                    });
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <h5 className="mb-3">{name}</h5>
                                    )} */}

                                    <div className="row">
                                        {Object.entries(titles).map(([key, value], index) => (
                                            <div className="col-lg-2" key={key}>
                                                <div className="input-space">
                                                    <label className="form-label">
                                                        Title {index + 1}
                                                    </label>

                                                    <input
                                                        className="form-control"
                                                        value={value}
                                                        placeholder="Enter Title"
                                                        onChange={(e) => {
                                                            setFormats(prev => ({
                                                                ...prev,
                                                                [name]: {
                                                                    ...prev[name],
                                                                    [key]: e.target.value
                                                                }
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* <div className="row">
                                        {Object.entries(formats).map(([name, titles]) => (
                                            <div key={name} className="mb-4">

                                                <h5>{name}</h5>

                                                <div className="row">
                                                    {titles.map((title, index) => (
                                                        <div className="col-lg-2" key={index}>
                                                            <label>Title {index + 1}</label>

                                                            <input
                                                                className="form-control"
                                                                value={title}
                                                                onChange={(e) => {
                                                                    const updated = [...titles];
                                                                    updated[index] = e.target.value;

                                                                    setFormats(prev => ({
                                                                        ...prev,
                                                                        [name]: updated
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>

                                            </div>
                                        ))}
                                    </div> */}

                                </div>
                            ))}
                        </div>

                        {isEdit ?
                            <>
                                <div className="row">
                                    <div className="mb-10 col-lg-6" style={{ paddingTop: "1rem" }}>
                                        <label className="form-label">Status</label>
                                    </div>
                                    <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                        <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                            <input
                                                className="form-check-input text-end"
                                                type="checkbox"
                                                checked={formatStatus === '1'}
                                                id="formatStatus"
                                                onChange={(e) => {
                                                    setFormatStatus(e.target.checked ? '1' : '0')
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </> : null
                        }
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form >
                </ModalBody >
            </Modal>
        </>
    );
};

export default ExternalResultFormat;